// utils/scale.js
let scale = 1;

/**
 * 初始化缩放
 * @param {number} designWidth 设计稿宽度
 * @param {number} designHeight 设计稿高度
 */
export function initScale(designWidth = 1920, designHeight = 1080) {
  const appDom = document.getElementById('app'); // 确保根节点ID为app
  if (!appDom) return;

  const setScale = () => {
    const clientWidth = window.innerWidth;
    const clientHeight = window.innerHeight;
        // 计算宽高缩放比例，取较小值以保证内容完全显示（留白）
    // 若希望填满屏幕（可能裁剪），可分别处理或使用 cover 逻辑
    const scaleX = clientWidth / designWidth;
    const scaleY = clientHeight / designHeight;
    
    // 这里选择保持比例完整显示，若需填满可改为 Math.max 或单独策略
    scale = Math.min(scaleX, scaleY);
    
    appDom.style.transform = `scale(${scale}) translate(-50%, -50%)`;
    appDom.style.width = `${designWidth}px`;
    appDom.style.height = `${designHeight}px`;
    appDom.style.position = 'absolute';
    appDom.style.top = '50%';
    appDom.style.left = '50%';
    appDom.style.transformOrigin = 'left top'; // 配合 translate 使用
        // 修正 translate 导致的偏移，使居中更准确
    // 注意：transform 顺序很重要，先 scale 后 translate 或者配合 margin
    // 更简单的居中方式：
    appDom.style.left = `${(clientWidth - designWidth * scale) / 2}px`;
    appDom.style.top = `${(clientHeight - designHeight * scale) / 2}px`;
    appDom.style.transform = `scale(${scale})`;
  };

  setScale();
  
  // 防抖监听 resize
  let timer = null;
  window.addEventListener('resize', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setScale();
    }, 100);
  });
}
